import {
    Button,
    TextField,
    MuiThemeProvider,
    createMuiTheme,
    FormControlLabel,
    Checkbox
} from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { Card, CardBody, CardHeader } from '../../../../_metronic/_partials/controls'
import { getAdvisorServiceById, postAdvisorService, updateAdvisorService, deleteAdvisorService } from '../../../../api/advisorService'
import { alertError, alertSuccess } from '../../../../utils/logger'
import Editor from '../../../components/editor/Editor'
import MultilanguageTabBlock from '../../../components/MultilanguageTabBlock'
import { useSkeleton } from '../../../hooks/useSkeleton'
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";


// Create theme for delete button (red)
const theme = createMuiTheme({
    palette: {
        secondary: {
            main: "#F64E60",
        },
    },
});

function getEmptyText() {
    return {
        title: {
            'es': "",
            'en': ""
        },
        description: {
            'es': "",
            'en': ""
        },
        maService: false
    }
}

export default function EditAdvisorServicePage() {
    const advisorServiceId = useParams().id;
    const history = useHistory();
    const { isLoading: isLoadingData, disableLoading: disableLoadingData, ContentSkeleton } = useSkeleton();

    const [advisorService, setAdvisorService] = useState(getEmptyText())
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);


    useEffect(() => {
        if (!advisorServiceId) {
            disableLoadingData();
            return
        }

        getAdvisorServiceById(advisorServiceId).then(res => {
            setAdvisorService(res.data)
            disableLoadingData()
        }).catch(error => {
            alertError({ error: error, customMessage: 'Could not get advisor service.' })
            history.push('/advisorServices')
        })
    }, [advisorServiceId, disableLoadingData, history])

    function saveTechnology() {
        if (!advisorServiceId) {
            postAdvisorService(advisorService)
                .then((res) => {
                    alertSuccess({
                        title: "Saved!",
                        customMessage: "Advisor service created successfully.",
                    });
                    history.push("/advisorServices");
                })
                .catch((error) => {
                    alertError({
                        error: error,
                        customMessage: "Could not save the advisor service.",
                    });
                });
        } else {
            updateAdvisorService(advisorServiceId, advisorService).then(res => {
                alertSuccess({ title: 'Saved!', customMessage: 'Changes successfully saved.' })
                history.push('/advisorServices')
            }).catch(error => {
                alertError({ error: error, customMessage: 'Could not save changes.' })
            })
        }
    }

    const handleChange = (element, lang) => (event) => {
        if (lang) {
            if (event.target.value === ' ')
                return
            if (!advisorService[element])
                advisorService[element] = {}
            let newText = advisorService[element]
            newText[lang] = event.target.value
            setAdvisorService({ ...advisorService, [element]: newText })
        } else
            setAdvisorService({ ...advisorService, [element]: event.target.value })
    }

    const handleChangeEditor = (element, lang, value) => {
        if (lang) {
            if (value === ' ')
                return
            if (!advisorService[element])
                advisorService[element] = {}
            let newText = advisorService[element]
            newText[lang] = value
            setAdvisorService({ ...advisorService, [element]: newText })
        } else
            setAdvisorService({ ...advisorService, [element]: value })
    }


    const renderMultilanguageTabContent = lang => {
        return (
            <>
                <TextField
                    label="Title"
                    value={(advisorService.title && advisorService.title[lang]) || ''}
                    onChange={handleChange('title', lang)}
                    margin="normal"
                    variant="outlined"
                    required
                />
                <Editor
                    body={(advisorService.description && advisorService.description[lang]) || ''}
                    setBody={new_body => handleChangeEditor('description', lang, new_body)}
                    className='max-height'
                    lang={lang}
                    placeholder={'Enter text content here...'}
                />
            </>
        )
    }

    if (isLoadingData)
        return <ContentSkeleton />

    return (
        <>
            <Card>
                <CardHeader title='Edit advisor service'>
                </CardHeader>
                <CardBody>
                    <MultilanguageTabBlock
                        multilanguageTabContent={renderMultilanguageTabContent}
                    />
                    <FormControlLabel
                        className='mt-5'
                        control={
                            <Checkbox
                                checked={advisorService?.maService}
                                onChange={() => setAdvisorService({ ...advisorService, maService: !advisorService?.maService })}
                                name="checkActive"
                            />
                        }
                        label="Possibility to sell or buy projects"
                    />
                </CardBody>
            </Card>
            <Button
                onClick={() => history.push('/advisorServices')}
                variant="outlined"
                style={{ marginRight: '20px' }}>
                Back
            </Button>
            <Button
                onClick={() => saveTechnology()}
                variant="outlined"
                color="primary"
                style={{ marginRight: '20px' }}>
                Save advisor service
            </Button>

            {advisorServiceId && (
                <>
                    <MuiThemeProvider theme={theme}>
                        <Button
                            onClick={() => setOpenConfirmDialog(true)}
                            variant="outlined"
                            color="secondary"
                            style={{ marginRight: "20px" }}
                        >
                            Delete advisor service
                        </Button>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                marginLeft: "auto",
                            }}
                        ></div>
                    </MuiThemeProvider>

                    <ConfirmDialog
                        title={"Are you sure you want to delete this advisor service?"}
                        open={openConfirmDialog}
                        setOpen={setOpenConfirmDialog}
                        onConfirm={() => {
                            deleteAdvisorService(advisorServiceId)
                                .then((res) => {
                                    alertSuccess({
                                        title: "Deleted!",
                                        customMessage: "Advisor service deleted successfully.",
                                    });
                                    history.push("/advisorServices");
                                })
                                .catch((error) => {
                                    alertError({
                                        error: error,
                                        customMessage: "Could not delete the advisor service.",
                                    });
                                });
                        }}
                    />
                </>
            )}
        </>
    );
}